import React from 'react';
import createSvgIcon from '../createNewIcon.js';
const Hu = createSvgIcon(React.createElement(React.Fragment, null,
    React.createElement("path", { d: "M21 0H0V14H21V0Z", fill: "#477050" }),
    React.createElement("path", { d: "M21 0H0V9.33333H21V0Z", fill: "#FAFAF9" }),
    React.createElement("path", { d: "M21 0H0V4.66667H21V0Z", fill: "#CE2939" })), 'Hu', { width: 21, height: 14, viewBox: '0 0 21 14' });
export default Hu;
